import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart, Star, ShoppingBag } from 'lucide-react';
import { useStore } from '../admin/context/ProductStore';
import './ProductCard.css';

export default function ProductCard({ product, onAddToCart }) {
  const { getFullUrl } = useStore();
  const [wished, setWished] = useState(false);
  const [added, setAdded] = useState(false);
  const displayWeight = product.weight ? product.weight.split(',')[0].trim() : '';
  const firstVariant = product.variants?.find(v => v.weight === displayWeight) || product.variants?.[0];
  const displayPrice = firstVariant?.price != null ? Number(firstVariant.price) : Number(product.price);
  const displayMrp = firstVariant?.mrp != null ? Number(firstVariant.mrp) : Number(product.mrp);
  const discount = displayMrp > 0 ? Math.round(((displayMrp - displayPrice) / displayMrp) * 100) : 0;

  const handleAdd = (e) => {
    e.preventDefault();
    setAdded(true);
    if (onAddToCart) onAddToCart({ 
      ...product, 
      weight: firstVariant?.weight || displayWeight || product.weight,
      price: displayPrice,
      mrp: displayMrp
    });
    setTimeout(() => setAdded(false), 1800);
  };

  const badgeClass = {
    gold: 'badge-gold',
    green: 'badge-green',
    cream: 'badge-cream',
  }[product.badgeType] || 'badge-gold';

  return (
    <Link to={`/product/${product.slug}`} className="product-card">
      {product.badge && (
        <span className={`product-card-badge badge ${badgeClass}`}>{product.badge}</span>
      )}
      <button
        className={`wishlist-btn ${wished ? 'wished' : ''}`}
        onClick={(e) => { e.preventDefault(); setWished(!wished); }}
        aria-label="Add to wishlist"
      >
        <Heart size={16} fill={wished ? 'currentColor' : 'none'} />
      </button>

      <div className="product-img-wrap">
        <img
          src={getFullUrl(product.images?.[0]?.url || product.image)}
          alt={product.name}
          className="product-img primary-img"
          loading="lazy"
          onError={(e) => {
            e.target.src = `https://via.placeholder.com/400x400/fdf8f0/7a4e2d?text=${encodeURIComponent(product.name)}`;
          }}
        />
        {product.images?.[1] && (
          <img
            src={getFullUrl(product.images[1].url)}
            alt={`${product.name} alternate`}
            className="product-img hover-img"
            loading="lazy"
          />
        )}
      </div>

      <div className="product-body">

        <p className="product-name">{product.name}</p>
        {product.shortDesc && <p className="product-short-desc">{product.shortDesc}</p>}
        <p className="product-weight">{displayWeight}</p>
        <div className="product-price-row">
          <span className="product-price">₹{displayPrice}</span>
          <span className="product-price-old">₹{displayMrp}</span>
          <span className="product-discount">{discount}% off</span>
        </div>
        {(() => {
          const isOutOfStock = firstVariant ? firstVariant.stock === 'outofstock' : product.stock === 'outofstock';
          return (
            <button
              className={`add-to-cart-btn ${added ? 'added' : ''}`}
              onClick={isOutOfStock ? (e) => e.preventDefault() : handleAdd}
              disabled={isOutOfStock}
              style={{
                backgroundColor: isOutOfStock ? '#ccc' : undefined,
                cursor: isOutOfStock ? 'not-allowed' : 'pointer'
              }}
            >
              {isOutOfStock ? (
                'Out of Stock'
              ) : added ? (
                <><span>✓</span> Added to Cart</>
              ) : (
                <><ShoppingBag size={14} /> Add to Cart</>
              )}
            </button>
          );
        })()}
      </div>
    </Link>
  );
}
